import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useVouchers = () => useQuery({ queryKey: [`vouchers`], queryFn: async () => {
    const callback = await API.get(`/vouchers`)
    return callback?.data
}})

export default useVouchers